import { useNavigate } from '@tanstack/react-router'
import { useAtom } from 'jotai'

import { useLogout } from '@/gen/publicApi/hooks'

import { DropdownMenuLabel } from '@/components/dropdown-menu'
import { PopoverClose } from '@/components/popover'

import { authTokenAtom } from '@/state/authToken'

const LogoutMenuItem = () => {
    const [, setAuthToken] = useAtom(authTokenAtom)
    const navigate = useNavigate()
    const logoutMutation = useLogout({
        mutation: {
            onSettled: () => {
                setTimeout(() => {
                    navigate({
                        to: '/login',
                    })
                    setAuthToken(undefined), 1
                })
            },
        },
    })

    return (
        <DropdownMenuLabel
            className="block px-6 font-thin cursor-pointer hover:bg-surface0"
            onClick={
                // @ts-expect-error - kubb codegen
                () => logoutMutation.mutate()
            }
        >
            <PopoverClose>Log out</PopoverClose>
        </DropdownMenuLabel>
    )
}

export default LogoutMenuItem
